import SUI from "../Assets/image/logo-31.png";
import USDC from "../Assets/image/logo-313.png";
import oshiSUI from "../Assets/image/logo-301.png";
import oSUI from "../Assets/image/logo-302.jpeg";
import trevinSUI from "../Assets/image/logo-306.png";
import jugSUI from "../Assets/image/logo-307.png";
import sSUI from "../Assets/image/logo-308.png";
import xBTC from "../Assets/image/logo-316.png";
import SOL from "../Assets/image/logo-322.png";
import DEEP from "../Assets/image/logo-318.svg";

const assets = [
  {
    symbol: "SUI",
    price: "$1.58",
    depositApr: "3.40%",
    borrowApr: "1.52%",
    ltv: "70%",
    bw: "1",
    deposits: { amount: "66.8M SUI", usd: "$106M" },
    borrows: { amount: "47.4M SUI", usd: "$75.0M" },
    logo: SUI,
  },
  {
    symbol: "USDC",
    price: "$0.9998",
    depositApr: "5.74%",
    borrowApr: "5.10%",
    ltv: "77%",
    bw: "1",
    deposits: { amount: "40.9M USDC", usd: "$41.0M" },
    borrows: { amount: "37.1M USDC", usd: "$37.1M" },
    logo: USDC,
  },
  {
    symbol: "oshiSUI",
    price: "$1.00",
    depositApr: "6.29%",
    borrowApr: "4.92%",
    ltv: "77%",
    bw: "1",
    deposits: { amount: "4.60M oshiSUI", usd: "$4.61M" },
    borrows: { amount: "3.92M oshiSUI", usd: "$3.93M" },
    logo: oshiSUI,
  },
  {
    symbol: "oSUI",
    price: "$1.0000",
    depositApr: "7.12%",
    borrowApr: "5.24%",
    ltv: "77%",
    bw: "1",
    deposits: { amount: "4.81M oSUI", usd: "$4.82M" },
    borrows: { amount: "794K oSUI", usd: "$794K" },
    logo: oSUI,
  },
  {
    symbol: "trevinSUI",
    price: "$90,376.95",
    depositApr: "2.88%",
    borrowApr: "3.00%",
    ltv: "60%",
    bw: "1",
    deposits: { amount: "80.4 trevinSUI", usd: "$7.27M" },
    borrows: { amount: "--", usd: "--" },
    logo: trevinSUI,
  },
  {
    symbol: "jugSUI",
    price: "$90,376.95",
    depositApr: "1.93%",
    borrowApr: "0.40%",
    ltv: "60%",
    bw: "1",
    deposits: { amount: "223 jugSUI", usd: "$20.2M" },
    borrows: { amount: "22.5 jugSUI", usd: "$2.04M" },
    logo: jugSUI,
  },
  {
    symbol: "sSUI",
    price: "$90,376.95",
    depositApr: "1.75%",
    borrowApr: "0.02%",
    ltv: "60%",
    bw: "1",
    deposits: { amount: "51.3 sSUI", usd: "$4.64M" },
    borrows: { amount: "0.21 sSUI", usd: "$19.3K" },
    logo: sSUI,
  },
  {
    symbol: "xBTC",
    price: "$90,376.95",
    depositApr: "2.63%",
    borrowApr: "1.05%",
    ltv: "60%",
    bw: "1",
    deposits: { amount: "150 xBTC", usd: "$13.6M" },
    borrows: { amount: "39.6 xBTC", usd: "$3.59M" },
    logo: xBTC,
  },
  {
    symbol: "SOL",
    price: "$1.58",
    depositApr: "3.40%",
    borrowApr: "1.52%",
    ltv: "70%",
    bw: "1",
    deposits: { amount: "66.8M SOL", usd: "$106M" },
    borrows: { amount: "47.4M SOL", usd: "$75.0M" },
    logo: SOL,
  },
  {
    symbol: "DEEP",
    price: "$0.9998",
    depositApr: "5.74%",
    borrowApr: "5.10%",
    ltv: "77%",
    bw: "1",
    deposits: { amount: "40.9M DEEP", usd: "$41.0M" },
    borrows: { amount: "37.1M DEEP", usd: "$37.1M" },
    logo: DEEP,
  },
];

export default function MainMarket() {
  return (
    <section className="px-4 py-6 mx-auto max-w-7xl">
      {/* Header */}
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-sm tracking-widest text-[#2469FF]">MAIN MARKET</h2>
        <div className="hidden gap-6 text-sm text-gray-300 md:flex">
          <span>
            Deposits <b className="text-white">$388M</b>
          </span>
          <span>
            Borrows <b className="text-white">$128M</b>
          </span>
          <span>
            TVL <b className="text-white">$260M</b>
          </span>
        </div>
      </div>

      {/* Desktop Header */}
      <div className="hidden grid-cols-7 px-4 py-3 text-xs text-gray-400 border-b md:grid border-white/10">
        <div>Asset</div>
        <div>Deposits</div>
        <div>Borrows</div>
        <div>LTV / BW</div>
        <div>Deposit APR</div>
        <div>Borrow APR</div>
        <div />
      </div>

      {/* Rows */}
      <div className="space-y-3 md:space-y-0">
        {assets.map((a) => (
          <div
            key={a.symbol}
            className="border bg-[#081126]  border-white/5 md:border-b md:border-white/10"
          >
            {/* Desktop */}
            <div className="items-center hidden grid-cols-7 px-4 py-4 md:grid">
              <div className="flex items-center gap-3">
                <img src={a.logo} alt="" className="w-8 h-8 rounded-full" />
                <div>
                  <p className="font-medium text-white">{a.symbol}</p>
                  <p className="text-xs text-gray-400">{a.price}</p>
                </div>
              </div>

              <Value {...a.deposits} />
              <Value {...a.borrows} />
              <div>
                {a.ltv} / {a.bw}
              </div>
              <Apr value={a.depositApr} />
              <Apr value={a.borrowApr} />
              <div />
            </div>

            {/* Mobile */}
            <div className="p-4 space-y-4 md:hidden">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <img src={a.logo} alt="" className="rounded-full w-9 h-9" />
                  <div>
                    <p className="font-semibold text-white">{a.symbol}</p>
                    <p className="text-sm text-gray-400">{a.price}</p>
                  </div>
                </div>
                <div className="flex items-center space-x-2 text-right">
                  <div>
                    <p className="text-xs text-gray-400">Deposit APR</p>
                    <p className="text-xs text-blue-300">{a.depositApr}</p>
                  </div>
                  <div>
                    <p className="text-xs text-gray-400 ">Borrow APR</p>
                    <p className="text-xs text-blue-300">{a.borrowApr}</p>
                  </div>
                </div>
              </div>

              <Row label="LTV / BW" value={`${a.ltv} / ${a.bw}`} />
              <Row
                label="Deposits"
                value={`${a.deposits.usd} · ${a.deposits.amount}`}
              />
              <Row
                label="Borrows"
                value={`${a.borrows.usd} · ${a.borrows.amount}`}
              />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

/* Helpers */
const Value = ({ amount, usd }) => (
  <div>
    <p className="text-white">{amount}</p>
    <p className="text-xs text-gray-400">{usd}</p>
  </div>
);

const Apr = ({ value }) => (
  <div className="font-medium text-blue-300">{value}</div>
);

const Row = ({ label, value }) => (
  <div className="flex justify-between text-sm">
    <span className="text-xs text-gray-400">{label}</span>
    <span className="text-xs text-white">{value}</span>
  </div>
);
